module.exports = __webpack_public_path__ + "img/bg.48246906.jpg";